
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M234.9 45c-10.8 2.2-23.9 7.5-33.2 13.4-6.8 4.3-122.3 99-131.6 107.9-10.9 10.5-19.8 25.7-24.3 41.2l-2.3 8v90c0 85.2.1 90.4 1.9 97 8.9 32.8 33.1 57.3 63.9 64.5 8.1 1.9 11.3 2.1 40.5 1.8l31.7-.3 6.7-3.2c9.4-4.4 16-10.9 20.6-20.2l3.7-7.5.5-45c.6-43 .7-45.4 2.7-50.9 1.2-3.2 3.3-7.7 4.7-10 3.5-6.1 12.7-14.4 19.3-17.5 5.2-2.4 7-2.7 16.3-2.7s11.1.3 16.3 2.7c6.6 3.1 15.8 11.4 19.4 17.6 1.4 2.3 3.5 7.1 4.6 10.5 2 5.8 2.1 9.1 2.6 50.8l.6 44.5 3.7 7.5c4.6 9.3 11.2 15.8 20.6 20.2l6.7 3.2 31.7.3c29.2.3 32.4.1 40.5-1.8 26.8-6.3 49.1-25.9 59.6-52.2 6.5-16.2 6.1-9.8 6.5-105.2.3-95.9.3-95.6-6-111.9-3.8-9.8-12.8-23.4-20.5-30.9-10.7-10.4-124.7-103.9-132.8-108.9-21.4-13.3-49.8-18.2-74.6-12.9"}})])
          )
        }
      }
    